import { RootState } from '../root.reducers';
import { OpenSearchFilterOptionDTO, OpenSearchLogDTO } from './log.types';

export const getLogs = (state: RootState): OpenSearchLogDTO[] => state.logs.logs;

export const getProcessNameOptions = (state: RootState): OpenSearchFilterOptionDTO[] => state.logs.processNameFilterOptions;

export const getSeverityOptions = (state: RootState): OpenSearchFilterOptionDTO[] => state.logs.severityFilterOptions;

export const getHostnameOptions = (state: RootState): OpenSearchFilterOptionDTO[] => state.logs.hostnameOptions;

export const getClusternameOptions = (state: RootState): OpenSearchFilterOptionDTO[] => state.logs.clusternameOptions;
